import { CommonConstants } from './../utilities/commonConstants';
import { HttpInterceptor } from './../services/httpInterceptor.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionHandlerService } from './sessionHandler.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { ConfigService } from './config.service';

@Injectable({
    providedIn: 'root'
})

export class SsoService {

    feaderatedServiceBaseUrl: string = 'http://authenticationservice.qa.bfsgodirect.com/v1/federated/';
    cipherKey: string = CommonConstants.SsoConstants.CIPHER_KEY;
    keyInput: string = '9898994242|Satyajeet|Thakare';
    encrypted: string;
    decrypted: string;
    onValidateSso$: Observable<ActivitiModel.MTResponse<any>>;

    constructor(
        private _httpInterceptor: HttpInterceptor,
        private _sessionHandlerService: SessionHandlerService,
        private _http: HttpClient
    ) { }

    public validateSsoToken(payload: any, callback) {
        const url = environment.serviceBaseUrls.DOMAIN01 + CommonConstants.SsoConstants.BusinessServiceLoginURL;
        let headerObj: HttpHeaders;
        headerObj = new HttpHeaders({
        });
        this.onValidateSso$ = this._httpInterceptor.applicationTokensPost(url, payload, false, headerObj);
        this.onValidateSso$.subscribe(resp => {
            callback('success', resp);
        }, (error) => {
            callback('error', null);
        });
    }

    horizontalLogin(payload: any) {
        const url = CommonConstants.APIURL.getTokenForUser.replace('{DOMAIN01}', environment.serviceBaseUrls.DOMAIN01);
        const headerObj: HttpHeaders = new HttpHeaders({
            "Content-Type": "application/json",
        });
        const options = { headers: headerObj };
        return this._http.post(url, payload, options);
    }

    businessServiceLogin(payload: any) {

        const headerObj: HttpHeaders = new HttpHeaders({
        });
        const url = environment.serviceBaseUrls.DOMAIN01 + CommonConstants.SsoConstants.BusinessServiceLoginURL;
        return this._httpInterceptor.Post(url, payload, false, headerObj, false);
        //   .subscribe((mtResponse: ActivitiModel.MTResponse<any>) => {
        //     console.log('mtResponse', mtResponse);
        //     if (!mtResponse.errorBean) {

        //     } else {

        //     }
        //   });
        // const url = environment.serviceBaseUrls.DOMAIN01 + CommonConstants.SsoConstants.BusinessServiceLoginURL;
        // const headerObj: HttpHeaders = new HttpHeaders({
        //     "Content-Type": "application/json",
        //     "authtoken": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.JWToken)
        // });
        // const options = { headers: headerObj };
        // return this._http.post(url, payload, options);
    }


    encryptUsingAES256() {
        let _key = CryptoJS.enc.Utf8.parse(this.cipherKey);
        let _iv = CryptoJS.enc.Utf8.parse(this.cipherKey);
        let encrypted = CryptoJS.AES.encrypt(
            JSON.stringify(this.keyInput), _key, {
            keySize: 16,
            iv: _iv,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return this.encrypted = encrypted.toString();
    }

    decryptUsingAES256() {
        let _key = CryptoJS.enc.Utf8.parse(this.cipherKey);
        let _iv = CryptoJS.enc.Utf8.parse(this.cipherKey);

        return this.decrypted = CryptoJS.AES.decrypt(
            this.encrypted, _key, {
            keySize: 16,
            iv: _iv,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }).toString(CryptoJS.enc.Utf8);
    }


    public getPrefilledUserData(payload: any) {
        let url = environment.serviceBaseUrls.DOMAIN01 + CommonConstants.SsoConstants.CUSTOMER_DEDUPE_API;
        const headerObj: HttpHeaders = new HttpHeaders({
            "Content-Type": "application/json",
            "authtoken": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.JWToken)
        });
        const options = { headers: headerObj };
        return this._http.post(url, payload, options);
    }

    miniOrangeAccessToken(accessSsoToken, JWToken) {
        const url = environment.serviceBaseUrls.DOMAIN01 + CommonConstants.APIURL.postMoauthLogin;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authtoken': JWToken
        });
        const body = {
            accessToken: accessSsoToken
        };
        return this._http.post(url, body, {headers})
    }

    // private getUrlBasedOnKey(key: string): string {
    //         return ConfigService.getInstance().getConfigObject().APIURL[key];
    // }
}
